import { useState } from 'react';

interface PlayerDemoProps {
  cover: string;
  title: string;
  episode: number;
}

export default function PlayerDemo({ cover, title, episode }: PlayerDemoProps) {
  const [playing, setPlaying] = useState(false);

  return (
    <div className="relative w-full aspect-video rounded-lg overflow-hidden bg-foreground-950">
      <img
        src={cover}
        alt={`${title}播放封面`}
        className="absolute inset-0 w-full h-full object-cover object-top opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/45 to-foreground-950/30"></div>

      <span className="absolute top-3 left-3 px-3 py-1 rounded-full text-xs bg-accent-500 text-background-50 font-semibold flex items-center gap-1">
        <i className="ri-error-warning-line"></i>
        演示模式
      </span>

      <span className="absolute top-3 right-3 px-3 py-1 rounded-full text-xs bg-background-50/15 text-background-50 font-medium border border-background-50/30">
        第 {episode} 集
      </span>

      {!playing ? (
        <button
          type="button"
          onClick={() => setPlaying(true)}
          className="absolute inset-0 flex flex-col items-center justify-center gap-4 cursor-pointer"
          aria-label="播放（演示）"
        >
          <span className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-accent-500 text-background-50 animate-float-slow">
            <i className="ri-play-fill text-3xl md:text-4xl"></i>
          </span>
          <span className="text-background-50 text-sm md:text-base font-medium">
            点击播放 · {title}
          </span>
        </button>
      ) : (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 px-6 text-center bg-foreground-950/80">
          <span className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-500 text-background-50">
            <i className="ri-movie-2-line text-2xl"></i>
          </span>
          <p className="text-background-50 font-heading font-semibold">演示模式</p>
          <p className="text-sm text-background-100 max-w-md leading-relaxed">
            本页面为前端演示区域，暂不支持真实视频播放与下载。正式上线后此处将接入真实播放器。
          </p>
          <button
            type="button"
            onClick={() => setPlaying(false)}
            className="mt-2 inline-flex items-center gap-2 px-4 py-2 rounded-md bg-background-50/15 hover:bg-background-50/25 text-background-50 text-sm border border-background-50/30 cursor-pointer transition-colors"
          >
            <i className="ri-close-line"></i>
            关闭提示
          </button>
        </div>
      )}
    </div>
  );
}